import type { PropsWithChildren } from 'react';
import { styled } from '@mui/material/styles';
import { DashboardSidebar } from './DashboardSidebar';
import { Box, Theme, useMediaQuery } from '@mui/material';
import DashboardNavbar from 'presenters/NavBar/DashboardNavbar';
import { useLayout } from 'contexts/layoutContext';
import AppVal from 'constants/frontend/app/AppVal';

const DashboardLayoutRoot = styled('div')<{}>(() => {
  const lgUp = useMediaQuery((theme: Theme) => theme.breakpoints.up('lg'), {
    noSsr: true,
  });
  const { isWideMode } = useLayout();
  const hasLeftPadding = lgUp && !isWideMode;

  return {
    display: 'flex',
    flex: '1 1 auto',
    maxWidth: '100%',
    marginTop: '64px',
    paddingLeft: hasLeftPadding ? AppVal.SIDE_BAR_WIDTH : 0,
  };
});

// consumer 역할
function MainWrapper({ children }: PropsWithChildren<{}>) {
  const { isWideMode } = useLayout();

  return (
    <Box
      sx={{
        display: 'flex',
        flex: '1 1 auto',
        flexDirection: 'column',
        width: '100%',
        minWidth: isWideMode
          ? `${AppVal.SIDE_BAR_WIDTH + AppVal.MAIN_AREA_OUTER_WIDTH}px`
          : `${AppVal.MAIN_AREA_OUTER_WIDTH}px`, // 900 + 여백 48포함
        maxWidth: isWideMode
          ? `${AppVal.SIDE_BAR_WIDTH + AppVal.MAIN_AREA_OUTER_WIDTH}px`
          : `${AppVal.MAIN_AREA_OUTER_WIDTH}px`, // 900 + 여백 48포함
      }}
    >
      {children}
    </Box>
  );
}

function DashboardLayout({ children }: PropsWithChildren<{}>) {
  return (
    <>
      <DashboardNavbar />
      <DashboardLayoutRoot>
        <MainWrapper>{children}</MainWrapper>
      </DashboardLayoutRoot>
      <DashboardSidebar />
    </>
  );
}

export { DashboardLayout };
